import { Injectable } from '@angular/core';
import {EnvironmentService} from "../environment/environment.service";
import {AuthService} from "../auth/auth.service";
import {Apollo, QueryRef} from "apollo-angular";
import {
  get_graph_event,
  post_graph_event,
  delete_graph_event,
  update_graph_event,
  cancel_graph_event
} from "./graphql/graph-request";
import {DatePipe} from "@angular/common";
import moment from "moment";
import {
  CompanyEventCalendarManagerService
} from "../company-events/company-events-calendar/company-event-calendar-manager.service";
import {create_CREA_outlook_event, create_outlook_event} from "../company-events/graphql/createCompanyEvent";
import {delete_crea_outlook_event} from "../company-events/graphql/updateCompanyEvent";

@Injectable({
  providedIn: 'root'
})
export class OutlookEventService {

  constructor(public env: EnvironmentService, public auth: AuthService, public apollo: Apollo,) { }

  createOutlookEvent(request:any, result: (data:any) => any){
    let graphResponse:any;
    this.apollo.mutate({
      mutation: post_graph_event,
      variables: {
        outlook_event_type_id: request['event_type_id'],
        attendees: request['attendees'],
        company_event_id: request['company_event_id'],
        event_datetime: request['event_datetime']
      },

    }).subscribe(({data}:any) => {
      let response = data.createGraphEvent;
      graphResponse = response
      this.apollo.mutate({
        mutation: create_outlook_event,
        variables: {
          event_id: response.id,
          outlook_event_type_id: request['event_type_id'],
          outlook_calendar_id: request['outlook_calendar_id'],
          is_cancelled: response.isCancelled
        }
      }).subscribe(({data} : any) => {
        let outlookEventResponse = data
        this.apollo.mutate({
          mutation: create_CREA_outlook_event,
          variables: {
            company_event_id: request['company_event_id'],
            outlook_event_id: outlookEventResponse.createOutlookEvent.id
          },
        }).subscribe(({data} : any) => {

          result({"outlook": graphResponse, "data": data})
        })
      })
    });
  }



  getOutlookEvent(data:any, result : (data:any) => any){
    let query = this.apollo.watchQuery({
      query: get_graph_event,
      variables: {
        id: data.id,
        calendar: data.calendar,
        user: data.user,
      }
    }).valueChanges.subscribe(({data}: any) => {
      if(data){
        let response = data.getGraphEvent;
        result(response);
        query.unsubscribe();
      }
    });

  }

  updateOutlookEvent(data:any, result: (data: any) => any){
    this.apollo.mutate({
      mutation: update_graph_event,
      variables: {
        attendees: data.attendees,
        event_id: data.event_id,
        calendar: data.calendar,
        user: data.user,
        company_event_id: data.company_event_id,
        outlook_event_type_id: data.outlook_event_type_id,
        event_datetime: data.event_datetime,
        attendees_only: data.attendees_only ? data.attendees_only : false
      }
    }).subscribe(({data} : any) => result(data))
  }
  deleteOutlookEvent(data:any){
      this.apollo.mutate({
        mutation: delete_graph_event,
        variables: {
          id: data.id,
          calendar: data.calendar,
          user: data.user
        }
      }).subscribe(({data}:any) => {

      })
  }

  cancelOutlookEvent(data:any, result: (data:any) => any){
    this.apollo.mutate({
      mutation: cancel_graph_event,
      variables: {
        id: data.event_id,
        calendar: data.calendar,
        user: data.user
      }
    }).subscribe(({response}:any) => {
      if(data.creaOutlook_id!==null && data.outlook_id!==null){
        this.apollo.mutate({
          mutation: delete_crea_outlook_event,
          variables: {
            id: data.creaOutlook_id,
            outlook_id: data.outlook_id
          }
        }).subscribe(({response}:any) => {
            result(response);
        })
      }
    })
  }
}
